import { differenceInDays, isAfter, isBefore } from 'date-fns';

export const getGiftTimelineStatus = (
  availableAt: string,
  expiresAt?: string | null,
  isPublished?: boolean,
): {
  status: 'upcoming' | 'active' | 'expiring' | 'expired' | 'inactive';
  label: string;
  className: string;
} => {
  if (!isPublished) {
    return {
      status: 'inactive',
      label: 'Inactive',
      className: 'text-gray-500',
    };
  }
  const now = new Date();
  const start = new Date(availableAt);
  const end = expiresAt ? new Date(expiresAt) : null;

  if (isBefore(now, start)) {
    return {
      status: 'upcoming',
      label: 'Upcoming',
      className: 'text-yellow-500',
    };
  }

  if (end) {
    if (isAfter(now, end)) {
      return {
        status: 'expired',
        label: 'Expired',
        className: 'text-gray-500',
      };
    }
    const daysUntilExpiry = differenceInDays(end, now);
    if (daysUntilExpiry <= 7) {
      return {
        status: 'expiring',
        label: 'Expiring Soon',
        className: 'text-yellow-500',
      };
    }
  }

  return {
    status: 'active',
    label: 'Active',
    className: 'text-green-500 border-green-500/20',
  };
};
